import React from "react";
import { useTranslation } from "react-i18next";

const SelectedItemsCount = ({ count, label = "Total Count : " }) => {
  const { t } = useTranslation();
  if (!count || count === 0) return null;

  return (
    <span
      className="dk-gray ftw-4"
      style={{
        padding: "4px 10px",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        fontSize: "0.875rem",
      }}
    >
      {t(label)} {count}
    </span>
  );
};

export default SelectedItemsCount;
